'use strict';

module.exports = {
  'seated': ['Plated', 'Buffet', 'Family Style'],
  'standing': ['Passed Hors d\'Oeuvres', 'Stationary']
};